import React, { useState } from "react";

import FormBasicInfo from "./FormBasicInfo";
import FormLegalStatus from "./FormLegalStatus";
import FormContactKREZCO from "./FormContactKrezco";
import FormExtra from "./FormExtra";
import FormCreateUser from "./FormCreateUser";

export default function FormCompany({ loading, setVroles, roles, vroles }) {
  const [data, setData] = useState({
    basicInfo: {},
    legalStatus: {},
    contact: {},
    extra: {},
    user: {},
  });
  const [page, setPage] = useState(0);

  if (loading) {
    return (
      <div className="form form--login form--white form--bordered">
        <label className="login-label">CARGANDO</label>
      </div>
    );
  }

  return (
    <div className="form form--login form--white form--bordered">
      {page === 0 && (
        <FormBasicInfo
          setVroles={setVroles}
          roles={roles}
          setPage={setPage}
          page={page}
          vroles={vroles}
          data={[data, setData]}
        />
      )}

      {page === 1 && (
        <FormLegalStatus setPage={setPage} page={page} data={[data, setData]} />
      )}

      {page === 2 && (
        <FormContactKREZCO
          setPage={setPage}
          page={page}
          data={[data, setData]}
        />
      )}

      {page === 3 && (
        <FormExtra setPage={setPage} page={page} data={[data, setData]} />
      )}

      {page === 4 && (
        <FormCreateUser setPage={setPage} page={page} data={[data, setData]} />
      )}
    </div>
  );
}